import { Component, ChangeDetectionStrategy, Input, HostBinding, ChangeDetectorRef } from '@angular/core';
import { NgClass } from '@angular/common';

@Component({
  selector: 'app-sidebar-flyout',
  standalone: true,
  imports: [],
  template: `
    <div class="flyout" [class.flyout--active]="isActive" role="presentation">
      <span class="flyout__label">{{ label }}</span>
      @if (isExternal) {
        <span class="flyout__external-icon material-symbols-outlined" aria-label="Opens in new window">open_in_new</span>
      }
    </div>
  `,
  styleUrl: './sidebar-flyout.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SidebarFlyoutComponent {
  private _label = '';
  @Input() set label(value: string) {
    if (value !== this._label) {
      this._label = value;
      this.cdr.markForCheck();
    }
  }
  get label() {
    return this._label;
  }

  private _isActive = false;
  @Input() set isActive(value: boolean) {
    if (value !== this._isActive) {
      this._isActive = value;
      this.cdr.markForCheck();
    }
  }
  get isActive() {
    return this._isActive;
  }

  private _isExternal = false;
  @Input() set isExternal(value: boolean) {
    if (value !== this._isExternal) {
      this._isExternal = value;
      this.cdr.markForCheck();
    }
  }
  get isExternal() {
    return this._isExternal;
  }

  @HostBinding('attr.aria-hidden') ariaHidden = true;
  constructor(private cdr: ChangeDetectorRef) {}
}
